import type { OS } from 'types';
import type { User } from 'types/User';

import algolia from '~/services/algolia.client';
import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  buttonName: string;
  isBot: boolean;
  legacyProductId: string;
  os: OS;
  pagePosition: string;
  productId: number;
  productName: string;
  queryID?: string | null;
  user: User;
};

class ClickNotificationEvent extends UserEvent<EventData> {
  sendToGtm() {
    if (!this.data.user.isLoggedIn) {
      gtm.pushToDataLayer({
        button_name: this.data.buttonName,
        event: 'register_intent',
        page_position: this.data.pagePosition
      });
    }

    gtm.pushToDataLayer({
      button_name: this.data.buttonName,
      event: 'notify_me_click',
      page_position: this.data.pagePosition,
      product_name: this.data.productName
    });
  }

  sendToAlgolia() {
    if (this.data.queryID) {
      algolia.convertedObjectIdAfterSearch({
        eventName: 'Notify Me Clicked',
        id: this.data.productId.toString(),
        queryID: this.data.queryID,
        user: this.data.user
      });
    }
  }

  collectServerEvents(): void {
    this.serverEvents.push({
      data: {
        is_user_logged_in: this.data.user.isLoggedIn,
        legacy_product_id: this.data.legacyProductId,
        os: this.data.os
      },
      type: 'notify_me_click'
    });
  }
}

export default ClickNotificationEvent;
